/*
  Command mutations
*/
export default {
  setList (state, payload) {
    state.list = payload
  }
}
